<template>
  <div class="container">
    <div class="">
      <div class="row justify-content-between d-none d-md-flex">
        <div class="col-xl-2 col-sm-3 bar-item">
          <input
            type="textfield"
            placeholder="Projektname"
            class="form-control"
            :value="currentProjectName"
            @input="changeProjectName"
          />
        </div>
        <div class="col-xl-5 col-md-6">
          <div class="row justify-content-center">
            <div
              class="col-xl-3 col-sm-3 bar-item"
              @click="switchEditor('background')"
              :class="currentEditor === 'background' ? 'bar-item-active' : ''"
            >
              <span>{{ t("message.background") }} </span>
            </div>
            <div
              class="col-xl-3 col-sm-3 bar-item"
              @click="switchEditor('buttons')"
              :class="currentEditor === 'buttons' ? 'bar-item-active' : ''"
            >
              <span>{{ t("message.keys") }} </span>
            </div>
            <div
              class="col-xl-3 col-sm-3 bar-item"
              @click="switchEditor('description')"
              :class="currentEditor === 'description' ? 'bar-item-active' : ''"
            >
              <span>{{ t("message.caption") }} </span>
            </div>
            <div
              class="col-xl-3 col-sm-3 bar-item"
              @click="switchEditor('leds')"
              :class="currentEditor === 'leds' ? 'bar-item-active' : ''"
            >
              <span>{{ t("message.LEDs") }} </span>
            </div>
          </div>
        </div>
        <div
          class="col-xl-2 col-sm-2 d-sm-none d-md-block bar-item"
          @click="printInlays()"
        >
          <font-awesome-icon
            :icon="['fas', 'print']"
            class="icon"
          ></font-awesome-icon
          >{{ t("message.print") }}
        </div>
        <!-- <div class="col-2 col-md-2 d-none d-md-block d-lg-none">
          <div class="row">
            <div class="col-6">
              <font-awesome-icon
                :icon="['fas', 'print']"
                class="icon"
              ></font-awesome-icon>
            </div>
            <div class="col-6">
              <font-awesome-icon
                :icon="['far', 'save']"
                class="icon"
              ></font-awesome-icon>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { printInlay, print } from "../../modules/printInlay";
export default {
  components: {},
  setup() {
    const store = useStore();
    const currentEditor = computed(() => store.getters.currentEditor);
    const currentProjectName = computed(() => store.getters.currentProjectName);
    const inlay = computed(() => store.getters.currentInlay);
    const { t } = useI18n();

    function switchEditor(editor) {
      store.dispatch("switchEditor", editor);
    }
    function changeProjectName(evt) {
      store.dispatch("setProjectName", evt.target.value);
    }
    function printInlays() {
      printInlay(inlay.value);
      print();
    }
    return {
      currentEditor,
      switchEditor,
      currentProjectName,
      changeProjectName,
      printInlays,
      t,
    };
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 890px) {
  .project-title {
    width: 20%;
    > .form-control {
      width: 50% !important;
    }
  }
}
.d-bar > .container {
  height: 50px;
  line-height: 50px;
  // min-width: 100vw;
}
.bar-item {
  cursor: pointer;
  padding-top: 7px;
  line-height: 30px;
  // padding-bottom: 10px;
}
.bar-item > span {
  position: relative;
  display: inline-block;
}
.bar-item:not(.bar-item-active) > span,
.bar-item:not(.bar-item-active) > span:after,
.bar-item:not(.bar-item-active) > span:before {
  transition: all 0.5s;
}

.bar-item > span:after {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 0%;
  content: ".";
  color: transparent;
  background: #ffde00;
  height: 1px;
}
.bar-item:not(.bar-item-active) > span:hover:after {
  width: 100%;
}
.bar-item-active > span {
  border-bottom: 1px solid #ffde00;
}
.bar-item-active {
  // border-top-right-radius: 5px;
  // border-top-left-radius: 5px;
  // border-top: 1px solid #eee;
  border-left: 1px solid #eee;
  border-right: 1px solid #eee;
  -webkit-box-shadow: 0px -6px 7px -1px rgba(201, 201, 201, 0.41);
  box-shadow: 0px -6px 7px -1px rgba(201, 201, 201, 0.41);
}
span:hover {
  color: #000;
}
.icon {
  margin-right: 3px;
}
.col-6 {
  padding: 0 7px !important;
}
</style>
